import { Campaign } from './campaign.model';
import { Parcel } from './parcel.model';
// FIXME sortir les ARConsoleFormatType, ARConsoleType ... de AR et dans un common pour tous les outils
import { ARConsoleFormatType, ARConsoleType, ARConsoleVersion } from './agrorendement-common-lists.model';
import { ZSNConsoleModulationType } from './zsn-lists.model';

export class ZSNCampaign extends Campaign {
  configuration: ZSNCampaignConfiguration;
}

export class ZSNCampaignConfiguration {
  id: number;

  startingOn: string | Date;
  endingOn: string | Date;

  createdAt: string | Date;
  updatedAt: string | Date;

  campaign: ZSNCampaign;
}

export class ZSNOrder {
  id: number;
  campaign: ZSNCampaign;
  orderItems: ZSNOrderItem[];

  createdAt: string | Date;
  updatedAt: string | Date;
}

export class ZSNOrderItem {
  id: number = null;

  completed: boolean = null;

  consoleModulationType: ZSNConsoleModulationType = null;
  consoleType: ARConsoleType = null;
  consoleVersion: ARConsoleVersion = null;
  otherConsoleVersion: string = null;
  consoleFormatType: ARConsoleFormatType = null;

  numZones: number = null;

  zone1: number = null;
  zone2: number = null;
  zone3: number = null;
  zone4: number = null;
  zone5: number = null;
  zone6: number = null;

  order: ZSNOrder = null;
  parcel: ZSNParcel = null;

  createdAt: string | Date = null;
  updatedAt: string | Date = null;
}

export class ZSNParcel extends Parcel {
  orderItem: ZSNOrderItem;
}
